import React, { useEffect, useState } from "react";
import EMPText from "../EmploymentForm/empText";
import EMPDate from "../EmploymentForm/empDate";
import InputField from "../InputField";
import _ from "lodash";
import {
  validateAadhaar,
  validateAlphabetsAndSpace,
  hasOnlySpaces,
} from "../../Helper/common";
import ImagePopup from "../ImagePopup";

const AadhaarNotLinked = ({
  verifiedAadhaarData,
  isAadhaarVerifiedViaOTP,
  aadhaarNumber,
  genderOptions,
  handleSaveDisabled,
  eAadhaarData,
  handleFileUpload,
  removeFile,
  aadhaarPreviews,
  aadhaarAlreadyVerified,
  dateOfBirth,
}) => {
  const [aadhaarData, setAadhaarData] = useState({
    aadhar_address: "",
    aadhar_dob: dateOfBirth,
    aadhar_father_name: "",
    aadhar_gender: "",
    aadhar_name: "",
    aadhar_number: "",
  });
  const [errorData, setErrorData] = useState({
    aadhar_address: false,
    aadhar_dob: false,
    aadhar_father_name: false,
    aadhar_gender: false,
    aadhar_name: false,
    aadhar_number: false,
  });

  const [modalImage, setModalImage] = useState("");
  const [showImageModal, setShowImageModal] = useState(false);
  useEffect(() => {
    window.scroll({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  useEffect(() => {
    if (Object.keys(verifiedAadhaarData).length > 0) {
      const updatedData = _.cloneDeep(verifiedAadhaarData);
      updatedData.aadhar_address = verifiedAadhaarData.aadhar_address;
      updatedData.aadhar_dob =
        verifiedAadhaarData.aadhar_dob == ""
          ? dateOfBirth
          : verifiedAadhaarData.aadhar_dob;
      updatedData.aadhar_father_name = verifiedAadhaarData.aadhar_father_name;
      updatedData.aadhar_gender = verifiedAadhaarData.aadhar_gender;
      updatedData.aadhar_name = verifiedAadhaarData.aadhar_name;
      updatedData.aadhar_number = verifiedAadhaarData.aadhar_number
        ? verifiedAadhaarData.aadhar_number
        : aadhaarNumber;
      let disableSave = false;
      for (var i in updatedData) {
        if (updatedData[i] == "" || updatedData[i] == null) {
          disableSave = true;
        }
      }
      handleSaveDisabled(disableSave, updatedData);
      setAadhaarData(updatedData);
    } else {
      const data = {
        aadhar_address: "",
        aadhar_dob: dateOfBirth,
        aadhar_father_name: "",
        aadhar_gender: "",
        aadhar_name: "",
        aadhar_number: "",
      };
      handleSaveDisabled(true);
      setAadhaarData(data);
    }
  }, []);

  useEffect(() => {
    if (isAadhaarVerifiedViaOTP || aadhaarAlreadyVerified) {
      handleSaveDisabled(false);
    } else {
      saveDisabledHandler(aadhaarData, errorData);
    }
  }, [aadhaarData]);

  useEffect(() => {
    if (isAadhaarVerifiedViaOTP || aadhaarAlreadyVerified) {
      handleSaveDisabled(false);
    } else {
      saveDisabledHandler(aadhaarData, errorData);
    }
  }, [aadhaarPreviews]);
  const handleSelectChange = (e) => {
    handleFieldChange(e.target.name, e.target.value);
  };
  const handleTextChange = (textValues) => {
    let errors = {};
    const { dataset, value } = textValues;
    if (dataset.fieldname == "aadhar_number") {
      const errData = _.cloneDeep(errorData);
      const isValid = validateAadhaar(value);
      const hasSpaces = hasOnlySpaces(value);
      const hasErr = !isValid || hasSpaces;
      errData[dataset.fieldname] = hasErr;
      errors = errData;
      setErrorData(errData);
    }
    if (
      dataset.fieldname == "aadhar_name" ||
      dataset.fieldname == "aadhar_father_name"
    ) {
      const errData = _.cloneDeep(errorData);
      const isValid = validateAlphabetsAndSpace(value);
      const hasSpaces = hasOnlySpaces(value);
      const hasErr = !isValid || hasSpaces;
      errData[dataset.fieldname] = hasErr;
      errors = errData;
      setErrorData(errData);
    }
    if (dataset.fieldname == "aadhar_address") {
      const errData = _.cloneDeep(errorData);
      const hasSpaces = hasOnlySpaces(value);
      errData[dataset.fieldname] = hasSpaces;
      errors = errData;
      setErrorData(errData);
    }
    handleFieldChange(dataset.fieldname, value, errors);
  };
  const handleSaveDate = (checkDetailsIndex, fieldName, value) => {
    handleFieldChange(fieldName, value);
  };
  const handleFieldChange = (fieldName, value, errors) => {
    const data = _.cloneDeep(aadhaarData);
    data[fieldName] = value;
    setAadhaarData(data);
    saveDisabledHandler(data, errors);
  };

  const saveDisabledHandler = (data, errors) => {
    let saveDisabled = false;
    for (var i in data) {
      if (data[i] == "" || data[i] == null) {
        saveDisabled = true;
        break;
      }
    }
    if (Object.keys(aadhaarPreviews).length !== 2) {
      saveDisabled = true;
    }
    for (var i in errors) {
      if (errors[i] == true) {
        saveDisabled = true;
        break;
      }
    }

    handleSaveDisabled(saveDisabled, data);
  };
  const fileUploadHandler = (inputName, file, chosenFiles) => {
    const caseCheckId = eAadhaarData.checksDetails[0].case_check_id;
    const docId = eAadhaarData.checksDetails[0].required_documents[0].id;
    const docSide = inputName.includes("front") ? "front" : "back";
    const record = {
      caseCheckId: caseCheckId,
      docId: docId,
      docside: docSide,
    };
    handleFileUpload("check_documents", chosenFiles, record, aadhaarData);
  };

  const handleDelete = async (e, docside) => {
    e.preventDefault();
    const recordArray = {};
    recordArray.doc_chk = eAadhaarData.checksDetails[0].case_check_id;
    recordArray.doc_ids =
      eAadhaarData.checksDetails[0].required_documents[0].id;
    recordArray.doc_ref = "all";
    recordArray.doc_side = docside;
    removeFile("check_documents", recordArray, aadhaarData);
  };

  const handleImageModal = (e, imagePreview) => {
    e.preventDefault();
    setModalImage(imagePreview);
    setShowImageModal(!showImageModal);
  };

  const closePopup = () => {
    setModalImage("");
    setShowImageModal(false);
  };

  return (
    <>
      {showImageModal && (
        <ImagePopup
          showModalBox={1}
          title={"Uploaded file"}
          description={"..."}
          isAdd={true}
          image={modalImage}
          closePopup={closePopup}
        />
      )}
      <div className={"form-two d-block"}>
        <div className="row">
          <EMPText
            fieldValue={aadhaarData.aadhar_name}
            handleTextChange={handleTextChange}
            fieldName={"aadhar_name"}
            errId={"aadhar_name"}
            isRequired={1}
            label={"Name as per document"}
            hasError={errorData.aadhar_name}
            isDisabled={isAadhaarVerifiedViaOTP || aadhaarAlreadyVerified}
          />
          <EMPText
            fieldValue={aadhaarData.aadhar_number}
            handleTextChange={handleTextChange}
            fieldName={"aadhar_number"}
            errId={"aadhar_number"}
            isRequired={1}
            label={" Aadhaar Card Number"}
            hasError={errorData.aadhar_number}
            isDisabled={isAadhaarVerifiedViaOTP || aadhaarAlreadyVerified}
          />
        </div>
        <div className="row">
          <EMPText
            fieldValue={aadhaarData.aadhar_father_name}
            handleTextChange={handleTextChange}
            fieldName={"aadhar_father_name"}
            errId={"aadhar_father_name"}
            isRequired={1}
            label={"Father’s Name"}
            hasError={errorData.aadhar_father_name}
            isDisabled={isAadhaarVerifiedViaOTP || aadhaarAlreadyVerified}
          />
          <div className="col-sm-4 col-md-12 col-xl-4">
            <div className="form-group">
              <InputField
                inputType={4}
                inputName={"aadhar_gender"}
                inputValue={aadhaarData.aadhar_gender}
                isInputMandatory={1}
                inputLabel={"Gender"}
                index={0}
                handleOnChange={handleSelectChange}
                options={genderOptions}
                isField={true}
                disabled={isAadhaarVerifiedViaOTP || aadhaarAlreadyVerified}
              />
              {errorData.aadhar_gender == true && (
                <p className="text-danger">Please provide valid input</p>
              )}
            </div>
          </div>
        </div>

        <div className="row">
          <EMPText
            fieldValue={aadhaarData.aadhar_address}
            handleTextChange={handleTextChange}
            fieldName={"aadhar_address"}
            errId={"aadhar_address"}
            isRequired={1}
            label={"Address"}
            divClass={"col-sm-4 col-md-12 col-xl-8"}
            hasError={errorData.aadhar_address}
            isDisabled={isAadhaarVerifiedViaOTP || aadhaarAlreadyVerified}
          />
        </div>

        <div className="row">
          <EMPDate
            paramStartDate={null}
            placeholder={"Date of Birth"}
            label={"Date of Birth"}
            isRequired={1}
            saveDate={handleSaveDate}
            checkDetailsIndex={null}
            errId={"aadhar_dob_id"}
            fieldName={"aadhar_dob"}
            fieldValue={aadhaarData.aadhar_dob}
            hasError={errorData.aadhar_dob}
            isDisabled={
              isAadhaarVerifiedViaOTP == true || aadhaarAlreadyVerified == true
                ? true
                : false
            }
          />
        </div>

        {!isAadhaarVerifiedViaOTP && !aadhaarAlreadyVerified && (
          <>
            <div className="row" style={{ marginBottom: "15px" }}>
              <h6 className="fnt-smi-bld mb-0" style={{ marginLeft: "15px" }}>
                Upload your document
              </h6>
            </div>
            <p className="text-muted">Aadhaar Card</p>
            <div className="row">
              <div className="col-sm-4 col-md-12 col-xl-4">
                <div className="form-group">
                  <InputField
                    inputType={8}
                    inputName={"aadhar_image_front"}
                    errorField={"aadhar_image_front"}
                    inputValue={aadhaarData.aadhar_gender}
                    isInputMandatory={1}
                    inputLabel={"Aadhaar Front"}
                    index={0}
                    handleFileUpload={fileUploadHandler}
                    isField={true}
                    uploadedFilePreview={
                      aadhaarPreviews["front"]
                        ? aadhaarPreviews["front"]
                        : "n.a."
                    }
                    handleImageModal={handleImageModal}
                    handleDelete={(e) => handleDelete(e, "front")}
                  />
                </div>
              </div>
              {/* {aadhaarPreviews["front"] && (
                <div className="col-auto d-flex align-items-center actions-mbl">
                  <i
                    class="fas fa-eye mr-3 cursor-pointer"
                    onClick={(e) =>
                      handleImageModal(e, aadhaarPreviews["front"])
                    }
                  ></i>
                  <i
                    class="fas fa-trash-alt text-danger cursor-pointer"
                    onClick={(e) => handleDelete(e, "front")}
                  ></i>
                </div>
              )} */}
            </div>

            <div className="row">
              <div className="col-sm-4 col-md-12 col-xl-4">
                <div className="form-group">
                  <InputField
                    inputType={8}
                    inputName={"aadhar_image_back"}
                    errorField={"aadhar_image_back"}
                    inputValue={aadhaarData.aadhar_gender}
                    isInputMandatory={1}
                    inputLabel={"Aadhaar Back"}
                    index={0}
                    handleFileUpload={fileUploadHandler}
                    isField={true}
                    uploadedFilePreview={
                      aadhaarPreviews["back"] ? aadhaarPreviews["back"] : "n.a."
                    }
                    handleImageModal={handleImageModal}
                    handleDelete={(e) => handleDelete(e, "back")}
                  />
                </div>
              </div>
              {/* {aadhaarPreviews["back"] && (
                <div className="col-auto d-flex align-items-center actions-mbl">
                  <i
                    class="fas fa-eye mr-3 cursor-pointer"
                    onClick={(e) =>
                      handleImageModal(e, aadhaarPreviews["back"])
                    }
                  ></i>
                  <i
                    class="fas fa-trash-alt text-danger cursor-pointer"
                    onClick={(e) => handleDelete(e, "back")}
                  ></i>
                </div>
              )} */}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default AadhaarNotLinked;
